import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import checkPermission from '../Common/permissions';

const contextTypes = {
  router: PropTypes.object,
};

const propTypes = {
  multiCurrenciesEdited: PropTypes.bool,
  multiCurrenciesIsEditing: PropTypes.bool,
  currencyRatesIsLoading: PropTypes.bool,
  currencyRatesError: PropTypes.string,
  currencyRates: PropTypes.arrayOf(PropTypes.shape({})),
  fetchCurrencyRates: PropTypes.func.isRequired,
  editMultiCurrencies: PropTypes.func.isRequired,
};

const defaultProps = {
  multiCurrenciesEdited: false,
  multiCurrenciesIsEditing: false,
  currencyRatesIsLoading: false,
  currencyRatesError: '',
  currencyRates: [],
};

class CurrencyManagement extends Component {
  constructor() {
    super();
    this.state = {
      currencyValues: {
        rows: [],
        selectedRows: [],
        editedRows: [],
        sortColumn: null,
        sortDirection: null,
      },
    };
  }

  componentDidMount() {
    if (this.props.currencyRates) {
      const { currencyRates } = this.props;
      currencyRates.map((currencyRate, index) => {
        currencyRate.Index = index;
      });
      const currencyValues = {
        ...this.state.currencyValues,
        rows: currencyRates,
        filters: {},
        sortColumn: null,
        sortDirection: null,
      };
      this.setState({ currencyValues });
    }
    this.props.fetchCurrencyRates();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currencyRates && nextProps.currencyRates !== this.props.currencyRates) {
      const { currencyRates } = nextProps;
      currencyRates.map((currencyRate, index) => {
        currencyRate.Idex = index;
      });
      const currencyValues = {
        ...this.state.currencyValues,
        rows: currencyRates,
        editedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      };
      this.setState({ currencyValues });
    }
    if (nextProps.multiCurrenciesEdited && nextProps.multiCurrenciesEdited !== this.props.multiCurrenciesEdited) {
      this.props.fetchCurrencyRates();
    }
  }

  getRows = () => Data.Selectors.getRows(this.state.currencyValues);

  getSize = () => this.getRows().length;

  updateRows = () => {
    this.props.editMultiCurrencies(this.state.currencyValues.editedRows);
  }

  rowGetter = (rowIdx) => {
    const rows = this.getRows();
    return rows[rowIdx];
  };

  handleGridSort = (sortColumn, sortDirection) => {
    const currencyValues = Object.assign({}, this.state.currencyValues, { sortColumn, sortDirection });
    this.setState({ currencyValues });
  };

  handleRowUpdated = (e) => {
    this.setState({ sortColumn: null, sortDirection: null });
    const rows = this.getRows();
    const editedRows = this.state.currencyValues.editedRows.slice(0);
    Object.assign(rows[e.rowIdx], e.updated);
    // if the element is already edited, remove the old one.
    editedRows.forEach((element, index) => {
      if (element.Idx === rows[e.rowIdx].Index) {
        editedRows.splice(index, 1);
      }
    });
    // push the row into the editedRows array
    editedRows.push(rows[e.rowIdx]);
    const currencyValues = {
      ...this.state.currencyValues,
      rows,
      editedRows,
    };
    this.setState({ currencyValues });
  };

  render() {
    const columns = [
      {
        key: 'CountryFullName',
        name: <Translate value="country" />,
        resizable: true,
        editable: false,
        width: 120,
        sortable: true,
        filterable: true,
      },
      {
        key: 'CurrencyCode',
        name: <Translate value="currency" />,
        resizable: true,
        editable: false,
        width: 120,
        sortable: true,
        filterable: true,
      },
      {
        key: 'ExchangeRate',
        name: <Translate value="rate" />,
        resizable: true,
        editable: true,
        width: 90,
        sortable: true,
        filterable: true,
      },
    ];

    if (this.props.currencyRatesIsLoading && !this.props.currencyRatesError) {
      return <Spinner />;
    } else if (this.props.currencyRatesError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">
            { JSON.stringify(this.props.currencyRatesError) }
          </div>
        </ContentWrapper>
      );
    }

    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="admin_tools" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="currency_management" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <Grid id="tax-management">
          <Row>
            <Panel id="tax-management-table">
              <ButtonToolbar className="tax-management-table-buttons">
                <Button
                  bsStyle="success"
                  className="buttonStyle"
                  onClick={event => this.updateRows(event)}
                  disabled={this.state.currencyValues.editedRows.length === 0 || !checkPermission('change_currency')}
                >
                  <em className="fa fa-save marginRightStyle" />
                  <Translate value="save" />
                </Button>
              </ButtonToolbar>
              <div id="edit-information">
                {
                  this.props.multiCurrenciesIsEditing && !this.props.multiCurrenciesEdited
                    && (
                      <div className="alert alert-info groups-saving-info">
                        <Translate value="saving" />
                      </div>
                    )
                }
                {
                  !this.props.multiCurrenciesIsEditing && this.props.multiCurrenciesEdited
                    && (
                      <div className="alert alert-success groups-saving-info">
                        <Translate value="saved" />
                      </div>
                    )
                }
              </div>
              <Row>
                <Col sm={12}>
                  <div style={{ maxWidth: '100%' }} id="TaxManagement-dataGrid1">
                    <ReactDataGrid
                      rowKey="Currency_id"
                      enableCellSelect
                      onGridSort={this.handleGridSort}
                      toolbar={<Toolbar />}
                      onRowUpdated={this.handleRowUpdated}
                      rowHeight={25}
                      minHeight={675}
                      columns={columns}
                      rowGetter={this.rowGetter}
                      rowsCount={this.getSize()}
                    />
                  </div>
                </Col>
              </Row>
            </Panel>
          </Row>
        </Grid>
      </ContentWrapper>
    );
  }
}

CurrencyManagement.contextTypes = contextTypes;
CurrencyManagement.propTypes = propTypes;
CurrencyManagement.defaultProps = defaultProps;

export default CurrencyManagement;



// WEBPACK FOOTER //
// ./master/jsx/components/Settings/currencyManagement.jsx